var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex align-items-center com-point-label" },
    [
      _vm.isLeft
        ? _c("point", { staticClass: "mr8", attrs: { type: _vm.type } })
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "com-point-label__text",
          class: { ellipsis: _vm.isEllipsis },
        },
        [_vm._v(_vm._s(_vm.name))]
      ),
      !_vm.isLeft
        ? _c("point", { staticClass: "ml8 mr24", attrs: { type: _vm.type } })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex-1 com-point-label__text" },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }